<template>
    <div class="Game">  
        <Canvas ref="canvas" id="Canvas"/>
        <template v-if="initialized">
            <Bounds ref="bounds"/>
            <Forms ref="forms"/>        
        </template>
    </div>
</template>

<script> 

import gsap from "gsap"
import { Application, Container, Graphics, Sprite } from 'pixi.js'
import Matter from 'matter-js'

import Bounds from './assets/Bounds.vue'
import Forms from './assets/Forms.vue'

export default {
    name: 'Game',
    mixins: [],
    components: { Bounds, Forms },
    data: () => ({
        initialized: false,
    }),
    beforeDestroy() {
        // if(this.rafID)
        //     cancelAnimationFrame(this.rafID)
        // this.$rendererWebgl.destroy()
        // this.$pixi.destroy()
    },
    mounted() {
        this.init()
    },
    methods: {  

        init() {

            this.$debug = true
            this.$autoplay = true
            this.$drag = false
            this.$over_blob = null
            this.$events = new PIXI.utils.EventEmitter()
            this.$animateTimer = 0
            this.$Engine = Matter.Engine
            this.$World = Matter.World
            this.$Bodies = Matter.Bodies
            this.$Body = Matter.Body
            this.$Events = Matter.Events
            this.$engine = this.$Engine.create()
            this.$world = this.$engine.world
            this.$world.gravity.y = .2

            this.$Events.on(this.$engine, 'collisionStart', (event)=> {

                // if(event.pairs && this.drag) {

                //     const point = event.pairs[0].collision.supports[0]
                //     const names = [ event.pairs[0].bodyA.name, event.pairs[0].bodyB.name ]

                //     if(names.indexOf(this.drag) > -1) {
                //         const other = (names[0] === this.drag) ? names[1] : names[0]
                //         if(other)
                //             this.blobStartCollide(other, point)
                //     }

                // }
            })

            // this.$debug ? this.initMatter() : this.initPixi()

            this.initMatter()

            this.$bodies = []
            this.$names = {}
            this.$mask = {}
            this.$couple = {}
            this.$World.add(this.$engine.world, this.$bodies)

            this.$Engine.run(this.$engine)

            // Matter.Runner.run($engine)
 
            this.$collided = false
            this.initialized = true
            this.animate()
        },

        // initPixi() {
        //     const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

        //     this.$pixi = new PIXI.Application(this.$el.offsetWidth, this.$el.offsetHeight, {
        //             antialias: true,
        //             resolution: window.devicePixelRatio,
        //             // resolution: 1,
        //             // antialias: false,
        //             forceCanvas: isFirefox ? false : true,
        //             autoResize: true,
        //             transparent: false,
        //             view: this.$refs.canvas
        //     })
        //     this.$rendererWebgl = new PIXI.WebGLRenderer()
        //     this.$background = new PIXI.Container()
        //     this.$forms = new PIXI.Container()
        //     this.$patterns = new PIXI.Container()
        //     this.$family = new PIXI.Container()
        //     this.$viewer = new PIXI.Container()
        //     this.$opts = new PIXI.Container()
        //     this.$pixi.stage.addChild(this.$background, this.$forms, this.$patterns, this.$family, this.$viewer, this.$opts)
        // },

        initMatter() {

            const Render = Matter.Render
            const Runner = Matter.Runner
            const MouseConstraint = Matter.MouseConstraint
            const Mouse = Matter.Mouse
            const render = Render.create(
            {
                canvas: this.$refs.canvas,
                engine: this.$engine,
                options: {
                        width: this.$el.offsetWidth,
                        height: this.$el.offsetHeight,
                        showVelocity: true
                }
            })

            Render.run(render)

            const runner = Runner.create()
            Runner.run(runner, this.$engine)

            const mouse = Mouse.create(render.canvas)
            const mouseConstraint = MouseConstraint.create(this.$engine,
            {
                mouse: mouse,
                constraint: {
                    stiffness: 0.2,
                    render: {
                        visible: true
                    }
                }
            })

            this.$World.add(this.$world, mouseConstraint)
            render.mouse = mouse
            Render.lookAt(render, {
                    min: { x: 0, y: 0 },
                    max: { x: this.$el.offsetWidth, y: this.$el.offsetHeight }
            })
        },

        animate(delta) {
            this.rafID = requestAnimationFrame(this.animate)

            // console.log('animate !');

            if(!this.$debug) {
                this.$animateTimer += delta
                this.$events.emit('animate', delta, this.$animateTimer)
            }
        },

    }
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'
@import '~@/commons/stylus/Hamburger-icon'

.Game 
    color black
    display flex
    position fixed
    top 0
    left 0
    width 100vw
    height 100%
    background-color black
    color white
       
</style>


